<template>
  <main>
    <Transition name="fade" mode="out-in">
      <div v-if="page" :key="$route.fullPath">
        <PageHeader :content="page.data.header" />
        <PageSections :sections="page.data.sections" />
      </div>
    </Transition>
  </main>
</template>

<script lang="ts">
import { ViewDataMixin } from "@/views/mixins"
import { PageHeader, PageSections } from "@/components/sections"
import { usePageStore } from "@/stores"

export default {
  name: "CustomPage",
  mixins: [ViewDataMixin],
  components: { PageHeader, PageSections },
  data() {
    return {
      page: null as Page | null,
    }
  },
  methods: {
    async init() {
      const page = await usePageStore().getBySlug(this.$route.params.slug as string)
      if (!page) {
        const locale = this.$i18n.locale || "fr"
        await this.$router.replace({ name: `catch-all:${locale}` })
        return
      }
      this.page = page
      await this.syncLocalizedSlug()
      document.title = `${this.page.seo?.title || this.page.data.header.title} | ${this.$t('site_title')}`
    },
    async syncLocalizedSlug() {
      if (!this.page?.slug) return

      const locale = (this.$i18n.locale || 'fr') as 'en' | 'fr'
      const currentSlug = this.$route.params.slug?.toString() || ''
      const localizedSlug = this.page.slug[locale]

      if (!localizedSlug || localizedSlug === currentSlug) return

      const page = await usePageStore().getBySlug(localizedSlug)
      if (!page) return

      this.page = page
      await this.$router.replace({
        name: `page.show:${locale}`,
        params: { slug: localizedSlug }
      })
    }
  },
  watch: {
    async '$route.params.slug'(newSlug, oldSlug) {
      if (newSlug === oldSlug) return
      await this.init()
    }
  }
}
</script>
